import { ReactNode } from "react";
import { default as BootStrapDropDown } from "react-bootstrap/Dropdown";
import classNames from "classnames";
import styles from "./dropdown.module.scss";
interface DropdownProps {
  children: ReactNode;
  menuClass?: string;
  title: string | ReactNode;
}
export const Dropdown: React.FC<DropdownProps> = ({
  children,
  title,
  menuClass,
}) => {
  return (
    <BootStrapDropDown className={styles.dropdown_container} align={"end"}>
      <BootStrapDropDown.Toggle className={styles.dropdown_button} as={"div"}>
        {title}
      </BootStrapDropDown.Toggle>

      <BootStrapDropDown.Menu
        className={classNames(styles.dropdown_menu, menuClass)}
      >
        <BootStrapDropDown.Item>{children}</BootStrapDropDown.Item>
      </BootStrapDropDown.Menu>
    </BootStrapDropDown>
  );
};
